import { render, staticRenderFns } from "./CollaborationRequest.vue?vue&type=template&id=14629e47&scoped=true&"
import script from "./CollaborationRequest.vue?vue&type=script&lang=js&"
export * from "./CollaborationRequest.vue?vue&type=script&lang=js&"
import style0 from "./CollaborationRequest.vue?vue&type=style&index=0&id=14629e47&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14629e47",
  null
  
)

export default component.exports